import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=0d837fd6&scoped=true"
import script from "./Organisation.vue?vue&type=script&lang=js"
export * from "./Organisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d837fd6",
  null
  
)

export default component.exports